module.exports = __webpack_public_path__ + "static/szenario1_2-19fa9a70a063c6c16c4168f756c0f67d.png";